import React from 'react';
import { Provider } from 'react-redux';
import configureStore from '../../../redux/store';

import WhyMyBizModal from './WhyMyBizModal';

const { store } = configureStore();

const ReduxWhyMyBizModal = (props) => (
	<Provider store={store}>
		<WhyMyBizModal {...props} />
	</Provider>);

export default ReduxWhyMyBizModal;
